import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;
const BASE = `${REACT_APP_REST_ENDPOINT}/admin-novita`;

/** Normalizza argomento: `feed` serializza come `{ filtri }` — non passare `{ filtri: {...} }`. */
function normalizeFeedFiltriArg(arg) {
  if (arg == null || typeof arg !== "object") return {};
  const hasOwnPaging =
    arg.offset != null ||
    arg.limite != null ||
    arg.limit != null ||
    arg.tipo_novita != null ||
    arg.filtro_pagamento != null ||
    (arg.cerca_nominativo != null && String(arg.cerca_nominativo).trim() !== "") ||
    (arg.id_agenzia != null && String(arg.id_agenzia).trim() !== "" && Number(arg.id_agenzia) > 0);
  if (arg.filtri && typeof arg.filtri === "object" && !hasOwnPaging) {
    return arg.filtri;
  }
  return arg;
}

function normSegnaChiaveId(id) {
  if (id == null) return "";
  const s = String(id).trim();
  if (s === "") return "";
  return /^\d+$/.test(s) ? String(parseInt(s, 10)) : s;
}

const AdminNovitaService = {
  feed(filtri = {}) {
    const url = `${BASE}/feed`;
    const payload = normalizeFeedFiltriArg(filtri);
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, { filtri: payload });
    });
  },

  segnaLetto(chiave_tipo, chiave_id) {
    const url = `${BASE}/segna-letto`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, {
        chiave_tipo: String(chiave_tipo || "").toLowerCase().trim(),
        chiave_id: normSegnaChiaveId(chiave_id),
      });
    });
  },

  segnaLavorato(chiave_tipo, chiave_id) {
    const url = `${BASE}/segna-lavorato`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, {
        chiave_tipo: String(chiave_tipo || "").toLowerCase().trim(),
        chiave_id: normSegnaChiaveId(chiave_id),
      });
    });
  },

  /**
   * [Solo dev] bulk lavorato iscrizioni con pagamento + fattura + verifica ok.
   * Usa POST /admin-novita/feed + flag nei filtri (stessa URL già in whitelist JWT).
   */
  bulkLavoratoTripleVerdeDev() {
    const url = `${BASE}/feed`;
    return new Promise((resolve, reject) => {
      ApiService.postRequest(resolve, reject, url, {
        filtri: { dev_bulk_lavorato_iscrizioni_triple_verde: true },
      });
    });
  },
};

export default AdminNovitaService;
